import { useRuntimeStore } from '@/store/runtime'


export default function user_logged(logged_value) {
    // all groups are required

    if (logged_value) {
        const user = useRuntimeStore()
        return user.logged === logged_value
    }

    // ignoring "guard"
    return false
}
